import {authClient} from '~/lib/auth-client'

export default defineNuxtRouteMiddleware(async (to, from) => {
  if (to.meta.unprotected === true) {
    return
  }

  const session = await authClient.getSession()
  const isLoggedIn = !!session?.data
  const {allowAccess} = useAuth()

  if (!isLoggedIn && to.path !== '/auth/login') {
    return navigateTo('/auth/login')
  }

  if (isLoggedIn && to.path === '/auth/login') {
    return navigateTo('/', {replace: true})
  }

  // Adding check that user has the correct organization
  if (isLoggedIn) {
    try {
      const result = await allowAccess(session.data?.user.id ?? '')

      if (result.success) {
        const {data, error} = await authClient.organization.setActive({
          organizationId: result.orgId // or organizationSlug: "my-org-slug"
        })

        if (error) {
          console.error('Failed to set active organization:', error.message)
          return
        }

        console.log('Successfully switched active organization:', data)
        return
      } else {
        console.log('failed to get success')
      }
    } catch (error) {
          return navigateTo('/error/invalid-access', {replace: true})
    }
  }
})
